import api from './api';
import rawData from '../data/official_uavt_iskenderun.json';

export const getNeighborhoodDevelopments = async () => {
  try {
    const response = await api.get('/api/NeighborhoodDevelopment/All');
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const getNeighborhoodDevelopmentByGuid = async (guid) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/GetByGuid', { guid });
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const addNeighborhoodDevelopment = async (data) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/Add', data);
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const updateNeighborhoodDevelopment = async (data) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/Update', data);
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const deleteNeighborhoodDevelopment = async (guid) => {
  try {
    const response = await api.post('/api/NeighborhoodDevelopment/Delete', { guid });
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

// --- İskenderun Yerel Adres & Resmi NVI/UAVT Sokak Servisi ---
export const getIskenderunNeighborhoods = async () => {
  return rawData.map(item => item.name).sort((a, b) => a.localeCompare(b, 'tr'));
};

export const getIskenderunStreets = async (neighborhoodName) => {
  if (!neighborhoodName) return [];

  const cleanSelected = neighborhoodName.replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
  const matchedObj = rawData.find(item => {
    const cleanItem = item.name.replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
    return cleanItem === cleanSelected || cleanItem.includes(cleanSelected) || cleanSelected.includes(cleanItem);
  });

  return matchedObj ? matchedObj.streets : [];
};








